import { TipoReceitaSncr } from '_metronic/helpers'

// `id` dos campos da revisão que as pendências focam. Ficam fora dos componentes para o Fast
// Refresh do Vite: arquivo de componente só exporta componente.
export const ID_TELEFONE_ENVIO = 'revisao-envio-telefone'
export const ID_EMAIL_ENVIO = 'revisao-envio-email'
export const idRetirarBloco = (tipo: TipoReceitaSncr) => `revisao-retirar-${tipo}`
